import {useContext} from 'react';
import {SettingsContext} from 'src/context/SettingsContext';
import {TypeSettingsContext} from 'src/defs/types';

export const useSettings = () => {
    const context = useContext<TypeSettingsContext>(SettingsContext);

    return context;
};
